'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

exports.__esModule = true;
exports['default'] = reducer;
exports.openTabForm = openTabForm;
exports.selectTab = selectTab;
exports.closeTab = closeTab;
exports.closeOthersTab = closeOthersTab;
exports.closeAll = closeAll;
exports.updateTab = updateTab;
var OPEN = '@@Tab/Open';
var CLOSE = '@@Tab/Close';
var CLOSE_OTHERS = '@@Tab/CloseOthers';
var CLOSE_ALL = '@@Tab/CloseAll';
var SELECT = '@@Tab/Select';
var UPDATE = '@@Tab/Update';

var initialState = {
	user: {
		tabs: [],
		selected: 0,
		stack: []
	},
	ticket: {
		tabs: [],
		selected: 0,
		stack: []
	},
	invoice: {
		tabs: [],
		selected: 0,
		stack: []
	},
	client: {
		tabs: [],
		selected: 0,
		stack: []
	},
	project: {
		tabs: [],
		selected: 0,
		stack: []
	},
	emailtemplate: {
		tabs: [],
		selected: 0,
		stack: []
	}
};

function reducer() {
	var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
	var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	switch (action.type) {
		case OPEN:
			var tab = {
				title: action.title,
				id: Math.random(),
				data: action.data.id,
				unsave: !!action.data.unsave,
				values: action.data.values,
				args: action.data,
				closable: true
			};
			state[action.module].tabs.push(tab);
			state[action.module].selected = tab.id;
			state[action.module].stack.push(tab.id);
			return _extends({}, state);

		case SELECT:
			state[action.module].selected = action.id;
			state[action.module].stack.push(action.id);

			return _extends({}, state);

		case UPDATE:
			var tab = state[action.module].tabs.filter(function (item) {
				return action.id == item.id;
			})[0];
			if (tab) {
				var index = state[action.module].tabs.indexOf(tab);
				state[action.module].tabs[index] = _extends({}, tab, action.tab);
				state[action.module].tabs = [].concat(state[action.module].tabs);
			}
			return _extends({}, state);

		case CLOSE:
			state[action.module].tabs = state[action.module].tabs.filter(function (item) {
				return action.id != item.id;
			});
			if (state[action.module].selected == action.id) {
				(function () {
					state[action.module].stack.pop();
					var lastid = state[action.module].stack.pop();
					var exists = state[action.module].tabs.filter(function (item) {
						return lastid == item.id;
					}).length > 0;
					while (!exists && state[action.module].stack.length > 0) {
						lastid = state[action.module].stack.pop();
						exists = state[action.module].tabs.filter(function (item) {
							return lastid == item.id;
						}).length > 0;
					}
					state[action.module].selected = exists ? lastid : 0;
				})();
			}
			return _extends({}, state);

		case CLOSE_OTHERS:
			state[action.module].selected = action.id;
			state[action.module].tabs = state[action.module].tabs.filter(function (item) {
				return action.id == item.id;
			});
			return _extends({}, state);

		case CLOSE_ALL:
			state[action.module].selected = 0;
			state[action.module].stack = [];
			state[action.module].tabs = [];
			return _extends({}, state);

		default:
			return state;
	}
}

function openTabForm(module, title, data) {
	return {
		type: OPEN,
		module: module,
		title: title,
		data: data,
		url: '/' + module + '/' + data.id
	};
}

function selectTab(module, id) {
	return {
		type: SELECT,
		url: function url(state) {
			var tab = state.tabs[module].tabs.filter(function (item) {
				return item.id == id;
			})[0];
			return '/' + module + (tab ? '/' + tab.data : '');
		},
		module: module,
		id: id
	};
}

function closeTab(module, id) {
	return {
		type: CLOSE,
		module: module,
		id: id,
		url: function url(state) {
			var selected = state.tabs[module].selected;
			var tab = state.tabs[module].tabs.filter(function (item) {
				return item.id == selected;
			})[0];
			return '/' + module + (tab ? '/' + tab.data : '');
		}
	};
}

function closeOthersTab(module, id) {
	return {
		type: CLOSE_OTHERS,
		module: module,
		id: id
	};
}

function closeAll(module, id) {
	return {
		type: CLOSE_ALL,
		module: module,
		id: id
	};
}

function updateTab(module, id, tab) {
	return {
		type: UPDATE,
		module: module,
		tab: tab,
		id: id
	};
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/tabs.js
 ** module id = 511
 ** module chunks = 2
 **/